// src/lib/format.ts — small shared date + priority helpers, ported from the
// prototype bp-helpers.jsx (BP_H). Pure functions; the views import these.

import { C } from "../theme";

// Seed anchor — mirrors the API's line-data.ts TODAY. The seeded plan is centred
// here; both move to live dates together when real feeds replace the seed.
export const TODAY = "2026-06-02";

export const MON = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export const MON3 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const DOWLONG: Record<string, string> = { SUN: "Sunday", MON: "Monday", TUE: "Tuesday", WED: "Wednesday", THU: "Thursday", FRI: "Friday", SAT: "Saturday" };
const DOW = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

export interface PrTone { label: string; fg: string; bg: string; bd: string; }
export const PR: Record<string, PrTone> = {
  urgent: { label: "Urgent", fg: "#8A2A1F", bg: "#F8DBD4", bd: "rgba(184,58,43,0.3)" },
  high:   { label: "High",   fg: "#9A5A1F", bg: "#F7E6CF", bd: "rgba(154,90,31,0.3)" },
  normal: { label: "Note",   fg: C.inkMute, bg: C.paperWarm, bd: C.hairline },
};

export function fmtLong(iso: string): string {
  const d = new Date(iso + "T00:00:00");
  return `${DOWLONG[DOW[d.getDay()]]} ${d.getDate()} ${MON[d.getMonth()]}`;
}
// Real wall-clock "today" (local) as YYYY-MM-DD — for date-driven views (turns,
// running-today) that work off real calendar dates, not the frozen seed anchor.
export function todayISO(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
export function addDaysISO(iso: string, n: number): string {
  const d = new Date(iso + "T00:00:00");
  d.setDate(d.getDate() + n);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
export function fmtShort(iso: string): string {
  const d = new Date(iso + "T00:00:00");
  return `${d.getDate()} ${MON3[d.getMonth()]}`;
}
export function fmtTime(ts: string): string {
  if (!ts || !ts.includes("T")) return "";
  return ts.split("T")[1].slice(0, 5);
}
// Relative time against the real wall clock — the seed is centred on ~now, so
// seeded notes read naturally ("yesterday") and fresh posts read "just now".
export function relTime(ts: string): string {
  if (!ts) return "";
  const now = new Date();
  const then = new Date(ts.length > 10 ? ts : ts + "T08:00");
  const mins = Math.round((now.getTime() - then.getTime()) / 60000);
  if (mins < 0) return fmtShort(ts.slice(0, 10));
  if (mins < 1) return "just now";
  if (mins < 60) return mins + "m ago";
  if (mins < 60 * 24) return Math.round(mins / 60) + "h ago";
  const days = Math.round(mins / 60 / 24);
  if (days === 1) return "yesterday";
  if (days < 7) return days + "d ago";
  return fmtShort(ts.slice(0, 10));
}
